import { RootState } from '@store';

export const selectConfiguration = (state: RootState) => {
  return state.configuration?.configuration;
};

export const selectIsMarginerEnabled = (state: RootState) => {
  return state.configuration?.configuration?.features?.isMarginerEnabled;
};

export const selectIsVehicleFilterCountsEnabled = (state: RootState) => {
  return state.configuration?.configuration?.features?.enableVehicleFilterCounts ?? false;
};
